// Ref: https://www.serpro.gov.br/menu/noticias/videos/calculodvcnpjalfanaumerico.pdf
// Converte caractere para valor numérico conforme tabela SERPRO (ASCII - 48)
const charToValue = (c) => c.charCodeAt(0) - 48;

const calcDV = (sequence) => {
  let sum = 0;
  let peso = 2;

  // Percorre da direita para a esquerda
  for (let i = sequence.length - 1; i >= 0; i--) {
    sum += charToValue(sequence[i]) * peso;
    peso = peso === 9 ? 2 : peso + 1;
  }

  const resto = sum % 11;
  return (resto === 0 || resto === 1) ? 0 : 11 - resto;
};

export const isValidCnpj = (value) => {
  if (!value) return false;

  
  const cleaned = value.replace(/[.\-/]/g, '').toUpperCase();

  if (cleaned.length !== 14) return false;

  const basePart = cleaned.substring(0, 12);
  const dvPart = cleaned.substring(12);
 

  if (!/^\d{2}$/.test(dvPart)) return false;

  const dv1 = calcDV(basePart);
  if (dv1 !== parseInt(dvPart[0])) return false;

  const dv2 = calcDV(basePart + dv1.toString());
  return dv2 === parseInt(dvPart[1]);
};